<template>
  <grid :items="agents" mode="agent" :cols="3" :perPage="-1" />
</template>

<script>
import Grid from "@/components/grid"
import Agents from "@/api/agents"
export default {
  name: "Agents",
  components: { Grid },
  data() {
    return {
      agents: []
    }
  },
  mounted() {
    this.setBusy(true)
    Agents.list().then(response => {
      this.agents = response.data
    }).finally(() => this.setBusy(false))
  }
}
</script>
